import styled from "styled-components";

import "../../../../GlobalStyles/Font.css";

export const ContainerModel = styled.div`
  max-width: 100%;
  background: #fff;
  border-radius: 20px;
  margin: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 744px) {
    max-width: 348px;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
  }
`;

export const ContentContainerModel = styled.div`
  max-width: 100%;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 358px;
  }

  @media (min-width: 744px) {
    max-width: 308px;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 100%;
    padding: 24px;
  }
`;

export const TitleModel = styled.h1`
  font-size: 24px;
  font-family: Exo2 Light;
  text-align: center;

  margin-top: 24px;

  @media (min-width: 1440px) {
    font-size: 36px;
  }
`;

export const ContainerQRCodeImage = styled.div`
  display: none;
  width: 100%;

  @media (min-width: 1024px) {
    max-width: 309px;
    display: block;
  }

  @media (min-width: 1440px) {
    max-width: 100%;
  }
`;

export const QRCodeImage = styled.img`
  width: 100%;
  height: auto;

  @media (min-width: 1440px) {
    width: auto;
    margin-left: auto;
    margin-right: auto;
    object-fit: none;
  }
`;

export const ContainerSecretCodeText = styled.div`
  width: 318px;
  margin-top: 20px;

  @media (min-width: 428px) {
    width: 358px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const CodeAuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 318px;

  @media (min-width: 428px) {
    max-width: 358px;
  }

  @media (min-width: 744px) {
    max-width: 308px;
  }
`;

export const CodeAuthText = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;
`;

export const CodeAuthSecret = styled.span`
  font-size: 16px;
  font-family: Exo2 Light;

  user-select: none;
  margin-top: 10px;

  @media (min-width: 428px) {
    font-size: 18px;
  }

  @media (min-width: 744px) {
    font-size: 16px;
  }
`;

export const TextMessageCode = styled.p`
  max-width: 318px;
  font-size: 20px;
  font-family: Exo2 Medium;
  text-align: justify;
  margin-top: 20px;

  @media (min-width: 428px) {
    max-width: 358px;
    font-size: 20px;
  }

  @media (min-width: 744px) {
    max-width: 308px;
  }

  @media (min-width: 1024px) {
    max-width: 269px;
  }

  @media (min-width: 1440px) {
    max-width: 100%;
  }
`;

export const StepsAuthCode = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;
  margin-top: 10px;

  @media (min-width: 744px) {
    max-width: 308px;
  }

  @media (min-width: 1440px) {
    width: 376px;
  }
`;
export const StepsAuthScanCode = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;
  margin-top: 10px;
  text-align: center;

  @media (min-width: 744px) {
    max-width: 308px;
  }

  @media (min-width: 1440px) {
    max-width: 100%;
  }
`;

export const LoadingSecretText = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;
  margin-top: 10px;
`;

export const FormTextAuthCode = styled.form`
  width: 100%;

  @media (min-width: 428px) {
    width: 358px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    width: 269px;
  }

  @media (min-width: 1440px) {
    width: 376px;
  }
`;

export const EnteredCode = styled.input`
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  width: 278px;
  font-size: 20px;
  padding: 13px 20px;
  font-family: Exo2 Light;
  margin-top: 20px;

  @media (min-width: 428px) {
    width: 318px;
  }

  @media (min-width: 744px) {
    width: 268px;
  }

  @media (min-width: 1024px) {
    width: 229px;
  }

  @media (min-width: 1440px) {
    width: 360px;
  }
`;

interface ButtonFinishProps {
  $filled: boolean;
}

export const ButtonFinish = styled.input<ButtonFinishProps>`
  background: ${(props) => (props.$filled ? "#1A50C6" : "#6B8EDA")};
  border-radius: 20px;
  width: 100%;
  padding: 12px;
  font-size: 20px;
  font-family: Exo2 Light;
  color: #fff;
  margin-top: 30px;

  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }

  @media (min-width: 428px) {
    width: 358px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    width: 269px;
  }

  @media (min-width: 1440px) {
    width: 400px;
  }
`;

export const ContainerErrors = styled.div`
  width: 318px;
`;
